/**
 * Preloads approval data for SSR.
 */

import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import ApprovalsContextApprovalsDataQuery from './__generated__/ApprovalsContextApprovalsDataQuery.graphql.ts';
import type {
	ApprovalsContextApprovalsDataQuery$data,
	ApprovalsContextApprovalsDataQuery$variables,
} from './__generated__/ApprovalsContextApprovalsDataQuery.graphql.ts';

export type PreloadApprovalsParams = {
	cloudId: string;
	contentId: string;
	contentStatus: 'CURRENT' | 'DRAFT';
};

export function preloadApprovals({ cloudId, contentId, contentStatus }: PreloadApprovalsParams) {
	const variables: ApprovalsContextApprovalsDataQuery$variables = {
		cloudId,
		contentId,
		contentStatus,
		transitionType: null,
	};

	return queryInterop<
		ApprovalsContextApprovalsDataQuery$data,
		ApprovalsContextApprovalsDataQuery$variables
	>({
		query: ApprovalsContextApprovalsDataQuery,
		variables,
	});
}
